import { Component, OnDestroy, OnInit } from '@angular/core';
import { bl_fi_jrnl_line_RowClass, EntityService, GenericDocContainerModel, GlcodeService, JournalService, Pagination } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../../visa';
import { forkJoin, iif, Observable, of, zip, Subject, } from 'rxjs';
import { catchError, map, mergeMap, debounceTime } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { JournalViewColumn1ViewModelActions } from '../../../generic-doc-view-model-controller/generic-doc-journal-view-model-controller/actions';
import { JournalViewColumn1ViewSelectors } from '../../../generic-doc-view-model-controller/generic-doc-journal-view-model-controller/selectors';
import { JournalViewColumnViewModelStates } from '../../../generic-doc-view-model-controller/generic-doc-journal-view-model-controller/states';
import { GridOptions } from 'ag-grid-enterprise';
import { SessionActions } from "../../../modules/session/session-controller/actions";
import { SessionSelectors } from '../../../modules/session/session-controller/selectors';
import { SessionStates } from '../../../modules/session/session-controller/states';
import { Store } from '@ngrx/store';
import { SharedUtilitiesHelperFunctions } from '../../helper-functions';

@Component({
  selector: 'app-journal-txn',
  templateUrl: './journal-txn.component.html',
  styleUrls: ['./journal-txn.component.css']
})

export class JournalTxnComponent implements OnInit, OnDestroy {

  protected subs = new SubSink();
  private columnMoveSubject: Subject<void> = new Subject<void>();
  private debounceTimeMs = 500;
  gridApi;
  gridColumnApi;
  rowData: [];
  gridOptions:GridOptions = {
    statusBar: {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', key: 'totalAndFilter', align: 'left' },
      ]
    },
    defaultColDef: {
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: { suppressFilterButton: true },
      minWidth: 100,
      flex: 1,
      sortable: true,
      resizable: true,
     // suppressCsvExport: true,
      floatingFilter: true
    },
    pagination: true
  }

  columnsDefs = [
    { headerName: 'GL Code', field: 'glcodeName', cellStyle: () => ({ 'text-align': 'left' }) },
    { headerName: 'Entity', field: 'entityName', cellStyle: () => ({ 'text-align': 'left' }) },
    { headerName: 'Description', field: 'descr', cellStyle: () => ({ 'text-align': 'left' }) },
    {
      headerName: 'Debit', field: 'amt_debit', type: 'numericColumn',
      valueFormatter: params => params.value? SharedUtilitiesHelperFunctions.currencyFormatter(params.value):'',
    },
    {
      headerName: 'Credit', field: 'amt_credit', type: 'numericColumn',
      valueFormatter: params => params.value? SharedUtilitiesHelperFunctions.currencyFormatter(params.value):'',
    },
  ];

  ccyCode;
  totalDebit: number = 0;
  totalCredit: number = 0;

  constructor(
    public readonly viewModelStore: Store<JournalViewColumnViewModelStates>,
    protected readonly sessionStore: Store<SessionStates>,
    protected journalService: JournalService,
    protected glcodeService: GlcodeService,
    protected entityService: EntityService,
  ) {}

  ngOnInit() {
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.closeToolPanel();
  }

  createData(genericDoc: GenericDocContainerModel) {
    const pagination = new Pagination();
    pagination.conditionalCriteria.push({
      columnName: 'guid_generic_doc_hdr',
      operator: '=',
      value: genericDoc.bl_fi_generic_doc_hdr.guid.toString()
    });

    pagination.conditionalCriteria.push({
      columnName: 'calcTotalRecords',
      operator: '=',
      value: 'false'
    });

    this.subs.sink = this.journalService.getByCriteria(pagination, AppConfig.apiVisa)
      .pipe(
        mergeMap(b => {
          const source: Observable<bl_fi_jrnl_line_RowClass>[] = [];
          console.log('journal', b);
          if (b.data.length > 0) {
            b.data[0].bl_fi_jrnl_lines.forEach(doc => {
              const entity$ = doc.guid_entity_hdr ? this.entityService.getByGuid(doc.guid_entity_hdr.toString(), AppConfig.apiVisa).pipe(
                catchError((err) => of(err))) : of(null);
              const glcode$ = this.glcodeService.getByGuid(doc.glcode_guid.toString(), AppConfig.apiVisa).pipe(
                catchError((err) => of(err)));
              const result$ = zip(entity$, glcode$)
                .pipe(
                  map(([entity, glcode]) => {
                    doc = Object.assign(doc,
                      { entityName: entity ? entity.error ? entity.error.code : entity?.data.bl_fi_mst_entity_hdr.name : "" },
                      { glcodeName: glcode.data.bl_fi_mst_glcode.name }
                    );
                    return doc;
                  })
                )
              source.push(result$);
            })
            return iif(() => b.data[0].bl_fi_jrnl_lines.length > 0,
              forkJoin(source).pipe(map(() => b.data[0])),
              of(b.data[0])
            );
          }
          return of(null);
        })
      ).subscribe(resp => {
        console.log('resp', resp);
        if (resp) {
          this.gridApi.setRowData(resp.bl_fi_jrnl_lines);

          this.ccyCode = resp.bl_fi_jrnl_hdr.ccy_code;
          this.totalCredit = 0;
          this.totalDebit = 0;
          resp.bl_fi_jrnl_lines.forEach(item => {
              this.totalDebit = this.totalDebit + <number>item.amt_debit;
              this.totalCredit = this.totalCredit + <number>item.amt_credit;
          })
        }
      // }, err => {
      //   this.gridApi.setRowData(of(null));
      //   console.error(err);  
      })
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  saveColumnStateToLocal(columnApi) {
    const columnState = columnApi.getColumnState();
    const serializedColumnState = JSON.stringify(columnState);
    this.viewModelStore.dispatch(JournalViewColumn1ViewModelActions.setGenericDocJournalListing_State({genericDocJournalListingState:serializedColumnState}))
  }
  ngAfterViewInit() {
    // Listen for column movement and debounce the action dispatch
    this.subs.add(
      this.columnMoveSubject
        .pipe(debounceTime(this.debounceTimeMs))
        .subscribe(() => {
          this.saveColumnStateToLocal(this.gridOptions.columnApi);
          this.saveColumnStateToBackend(this.gridOptions.columnApi);
        })
    );
    
    this.subs.sink = this.viewModelStore
      .select(JournalViewColumn1ViewSelectors.selectGenericDocJournalListing_State)
      .subscribe((data) => {
        if (!data) {
          this.subs.sink = this.sessionStore
            .select(SessionSelectors.selectPersonalSettings)
            .subscribe((data) => {
              if (data.genericDocJournalListingState) {
                console.log("data",data.genericDocJournalListingState);
                this.viewModelStore.dispatch(
                  JournalViewColumn1ViewModelActions.setGenericDocJournalListing_State({
                    genericDocJournalListingState: data.genericDocJournalListingState,
                  })
                );
              }
            });
        }
      });
    
    setTimeout(()=>{
      let serializedColumnState;
      this.subs.sink = this.viewModelStore.select(JournalViewColumn1ViewSelectors.selectGenericDocJournalListing_State).subscribe(data=>{
        if(data){
          serializedColumnState=data;
        }
      })
      if (serializedColumnState) {
        const newColumnState = JSON.parse(serializedColumnState);
        const currentColumnState = this.gridOptions.columnApi.getColumnState();
        const currentColumnIds = new Set(currentColumnState.map(column => column.colId));
      
        const hiddenColumns = {};
          currentColumnState.forEach(column => {
            if (column.hide) {
              hiddenColumns[column.colId] = true;
            }
          });
        const filteredNewColumnState = newColumnState.filter(column => currentColumnIds.has(column.colId));
        const combinedColumnState = filteredNewColumnState.map(column => {
            if (hiddenColumns[column.colId] !== undefined) {
              column.hide = hiddenColumns[column.colId];
            }
            return column;
          });
          this.gridOptions.columnApi.applyColumnState({
            state: combinedColumnState,
            applyOrder: true, // Set this to true to forcefully apply the state
          });
          console.log('Column State Applied:', combinedColumnState);
      }
    
    },2000);
    
   
    
  }
  
  // Define a function to save column state to the backend
  saveColumnStateToBackend(columnApi) {
    const columnState = columnApi.getColumnState();
    const serializedColumnState = JSON.stringify(columnState);
    this.sessionStore.dispatch(SessionActions.saveColumnStateInit({ settings: {genericDocJournalListingState:serializedColumnState} }));
   }
  ngAfterViewChecked() {
    // Listen for column visibility changes
    this.gridOptions.api.addEventListener("columnVisible", (event) => {
      this.columnMoveSubject.next();
    });
    // Listen for column movement
    this.gridOptions.api.addEventListener("columnMoved", (event) => {
      this.columnMoveSubject.next();
    });
  }
}
